import ActionButton, { Action } from "components/buttons/action-button";
import { DocumentTextIcon, PaperClipIcon } from "@heroicons/react/24/outline";

import React from "react";
import clsx from "clsx";
import { useAppNavigate } from "_graphql/cache/auth";
import { withPermissions } from "utils";

const documents = [
  {
    name: "Placing slip",
    description: "View and manage treaty placing slip",
    icon: <DocumentTextIcon className="h-16 text-tertiary" />,
  },
  {
    name: "Cover note",
    description: "View and manage treaty cover note",
    icon: <DocumentTextIcon className="h-16 text-tertiary" />,
  },
];

type Props = {};

const TreatyDocuments = (props: Props) => {
  const navigate = useAppNavigate();
  const handleAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
    () => {
      navigate({
        search: (old) => ({
          ...old,
          id,
          modal: action,
        }),
      });
    };

  return (
    <div className={clsx("bg-card-500 rounded-xl shadow-lg overflow-hidden")}>
      <div className="px-6 py-5 border-b border-gray-700/50">
        <h3 className="text-xl font-semibold text-primary">Documents</h3>
        <p className="mt-1 text-sm text-tertiary">
          Treaty documentation and files
        </p>
      </div>

      <div className="p-6">
        <ul className="divide-y divide-gray-700/30">
          {documents.map((document) => (
            <li
              key={document.name}
              className="py-4 flex items-center justify-between"
            >
              <div className="flex items-center">
                <PaperClipIcon className="h-5 w-5 text-tertiary" />
                <div className="ml-4">
                  <p className="text-sm font-medium text-primary">
                    {document.name}
                  </p>
                  <p className="text-xs text-tertiary">
                    {document.description}
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <ActionButton
                  onClick={handleAction(document.name, "view")}
                  action="view"
                />
                {withPermissions([
                  "*:*",
                  "treaties:*",
                  "treaties:manage",
                  "treaties:send",
                ])(
                  <ActionButton
                    onClick={handleAction(document.name, "send")}
                    action="send"
                  />
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TreatyDocuments;
